import { render, staticRenderFns } from "./OccurrencesConfigTable.vue?vue&type=template&id=2a217174&"
import script from "./OccurrencesConfigTable.vue?vue&type=script&lang=js&"
export * from "./OccurrencesConfigTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports